document.addEventListener("DOMContentLoaded", function () {
  let data = window.TRADEIN_DATA_ESPECIAL || [];

  const selectActual = document.getElementById("modeloActual");
  const selectDeseado = document.getElementById("modeloDeseado");

  const modelosRecibidos = [...new Set(data
    .filter(d => (d["Tipo"] || "").toLowerCase().includes("trade-in"))
    .map(d => d["Modelo"].trim())
  )];

  const modelosVenta = [...new Set(data
    .filter(d => (d["Tipo"] || "").toLowerCase().includes("venta"))
    .map(d => d["Modelo"].trim())
  )];

  modelosRecibidos.forEach(m => {
    const option = document.createElement("option");
    option.value = m;
    option.textContent = m;
    selectActual.appendChild(option);
  });

  modelosVenta.forEach(m => {
    const option = document.createElement("option");
    option.value = m;
    option.textContent = m;
    selectDeseado.appendChild(option);
  });
});

function calcular() {
  const data = window.TRADEIN_DATA_ESPECIAL || [];

  const actual = document.getElementById("modeloActual").value;
  const deseado = document.getElementById("modeloDeseado").value;
  const bateria = document.getElementById("bateriaMantenimiento").value === "SI";
  const tapa = document.getElementById("tapaTrasera").value === "SI";

  const equipo = data.find(d => d["Modelo"].trim() === actual.trim() && d["Tipo"].toLowerCase().includes("trade-in"));
  const objetivo = data.find(d => d["Modelo"].trim() === deseado.trim() && d["Tipo"].toLowerCase().includes("venta"));

  if (!equipo || !objetivo) {
    document.getElementById("resultado").textContent = "Modelo no encontrado en los datos, por favor verifica la selección.";
    return;
  }

  const safeNumber = str => parseFloat((str || "0").toString().replace(",", "").trim()) || 0;

  const valorRecibido = safeNumber(equipo["Precio recibido"]);
  const valorVenta = safeNumber(objetivo["Precio venta"]);

  if (valorRecibido === 0 || valorVenta === 0) {
    let mensaje = "Equipo no disponible para realizar el cálculo:\n\n";
    if (valorRecibido === 0) mensaje += `${actual} no disponible para recepción.\n`;
    if (valorVenta === 0) mensaje += `${deseado} no tiene stock disponible.\n`;
    document.getElementById("resultado").textContent = mensaje;
    return;
  }

  const descuentoBateria = bateria ? safeNumber(equipo["Batería en mantenimiento"]) : 0;
  const descuentoTapa = tapa ? safeNumber(equipo["Tapa trasera quebrada"]) : 0;

  const tarifaServicio = 0;
  const valorRecibidoReal = valorRecibido - descuentoBateria - descuentoTapa;
  const diferencia = (valorVenta - valorRecibidoReal) + tarifaServicio;


  // --- Mostrar valor recibido completo ---
    let resultado = `
    <div style="text-align:center;">
      Recibimos tu <strong>${actual}</strong> en <strong>$${valorRecibido.toFixed(2)}</strong>
    </div><br>
  `;

  if (bateria) {
    resultado += `
      <div style="text-align:center;">Descuento por batería: <strong>$${descuentoBateria.toFixed(2)}</strong></div><br>
    `;
  }

  if (tapa) {
    resultado += `
      <div style="text-align:center;">Descuento por tapa trasera: <strong>$${descuentoTapa.toFixed(2)}</strong></div><br>
    `;
  }

   if (diferencia > 0) {
    resultado += `
      <div style="text-align:center;">
        Al entregar tu equipo, solo pagarías <strong>$${diferencia.toFixed(2)}</strong>
        por el <strong>${deseado}</strong>
      </div><br>
    `;
  } else {
    resultado += `
      <div style="text-align:center;">
        Solo realizamos cambios por equipos de gama más alta.
      </div><br>
    `;
  }

resultado += `
    <div style="font-size:0.8em;color:red;text-align:center;margin-top:5px;">
      Estos precios navideños son validos, solo para equipos adquiridos con nosotros.
    </div>
  `;

  document.getElementById("resultado").innerHTML = resultado;

  document.getElementById("resultado").innerHTML = resultado;

// Mostrar el botón de WhatsApp y asignar evento
const btnWhatsapp = document.getElementById("btnWhatsapp");
btnWhatsapp.style.display = "inline-block";
btnWhatsapp.onclick = enviarWhatsApp;

}

function enviarWhatsApp() {
  const resultadoDiv = document.getElementById("resultado");
  const textoCotizacion = resultadoDiv.textContent || resultadoDiv.innerText || "";

  const mensaje = `Hola, recibí esta cotización por el *Elfo de iphonízate* y estoy interesado en realizar el cambio:\n\n${textoCotizacion}`;

  const numeroWhatsApp = "584142101257"; // ← Cambia por tu número real
  const textoURL = encodeURIComponent(mensaje);
  const url = `https://wa.me/${numeroWhatsApp}?text=${textoURL}`;

  window.open(url, "_blank");
}